module.exports = __webpack_public_path__ + "media/app/assets/navIcons/arena-2v2-fa1bf2212ec131b7457ff3d916e43a45.png";